import { createFileRoute } from '@tanstack/react-router';
import SessionExpired from '@my-pages/features/auth/views/SessionExpired.tsx';

export const Route = createFileRoute('/_static/utloggad')({
    component: SessionExpired,
});
